export const projects = [
  {
    name: "Operational Dashboard for a Walking Robot",
    date: "2021",
    company: "University of Queensland",
    description:
      "I developed an operational dashboard to monitor and control a chicken-sized bipedal walking robot. The dashboard communicates to the robot over Bluetooth and displays the robot’s operating status, motion telemetry and condition. It also supports real-time updating of the balance controllers.",
    tags: ["Electron.js", "Vue.js", "SCSS", "SerialPort.js", "Chart.js"],
    imageLink: require("@/assets/images/tgr_gui.png"),
    categories: ["HIGHLIGHTS", "TECH"]
  },
  {
    name: "Box Boy: Java Game Engine",
    date: "2021",
    company: "University of Queensland",
    description:
      "In a team of two, I developed a game engine and preliminary game called Box Boy. Key areas of the game engine that I designed and implemented include the input system, resource loader, the UIs and menus, and the game art. The codebase and wiki are to be used by a second-year software studio course at UQ.",
    tags: ["Java", "libGDX", "Mockito"],
    buttons: [
      {
        label: "Video Demo",
        link: "./files/box_boy.mkv"
      }
    ],
    imageLink: require("@/assets/images/box_boy.jpg"),
    categories: ["HIGHLIGHTS", "TECH"]
  },
  {
    name: "Atlassian Internship Experience Article",
    date: "2021",
    description:
      "My article '12 Weeks of Remotely Interning for Atlassian as a Software Developer' details my experience remotely interning for Atlassian. It covers the application process, internship activities, technical details, what I didn’t expect and my elevator pitch for why I recommend the internship.",
    imageLink: require("@/assets/images/atlassian_article.jpg"),
    buttons: [
      {
        label: "View Article",
        link:
          "https://anastasia-laczko.medium.com/12-weeks-of-remotely-interning-for-atlassian-as-a-software-developer-b0ee4bfdacb0"
      }
    ],
    categories: ["CONTENT"]
  },
  {
    name: "Elysian",
    date: "2020",
    description:
      "Elysian is a digital market place concept I developed with three law students for the 2020 KWM Transform Law Prize.  Our 5-minute pitch won First Place. Elysian uses machine learning to connect lawyers and firms with pro bono opportunities and provides insights through data analytics.",
    imageLink: require("@/assets/images/Elysian.png"),
    buttons: [
      {
        label: "UQ Law Article",
        link:
          "https://law.uq.edu.au/article/2020/10/students-help-bridge-pro-bono-gap-prize-winning-idea"
      }
    ],
    tags: ["Adobe XD"],
    categories: []
  },
  {
    name: "Skill+",
    date: "2020",
    description:
      "Skill+ is a start up concept I developed with three other students for the UQ Ventures Virtual Hackathon. It is a digital career advisor which uses LinkedIn data and AI to generate career pathways and skill trees for tech graduates. Our 3-minute pitch received First Place and the People’s Choice award. I designed the UI mock-ups in Adobe XD.",
    imageLink: require("@/assets/images/skillplus.png"),
    buttons: [
      {
        label: "Pitch Video",
        link: "https://youtu.be/aT6ULso7yok"
      }
    ],
    tags: ["Adobe XD"],
    categories: ["TECH"]
  },
  {
    name: "Mechatronics Team Project II: Freight Handling",
    date: "2020",
    description:
      "In a multi-disciplanry team of four, I created a miniature rail network and crane system used to transport containers. I implemented wireless communication between a Python server and STM32 microcontrollers via ESP8266 embedded WIFI modules. I also interfaced Xbox controlelrs with the system to operate the cranes and train.",
    imageLink: require("@/assets/images/crane.jpg"),
    buttons: [
      {
        label: "Video Demo",
        link: "./files/crane_movement.mp4"
      }
    ],
    tags: ["Python", "C", "Pygame"],
    categories: ["HIGHLIGHTS", "TECH"]
  },
  {
    name: "Girls In Computer Science Illustration",
    date: "2020",
    description:
      "I designed a vector illustration using Adobe Illustrator to be used on stickers for a UQ event promoting girls in computing.",
    imageLink: require("@/assets/images/compsci-sticker.png"),
    categories: ["DESIGN"],

    tags: ["Adobe Illustrator"]
  },
  {
    name: "UQ MARS Website",
    date: "2020",
    description:
      "I created a new website for the student-run UQ Mechatronics and Robotics Society.",
    imageLink: require("@/assets/images/uqmars.jpg"),

    buttons: [{ label: "Visit Site", link: "http://www.uqmars.com" }],
    categories: ["WEB DEV"],
    tags: ["WordPress"]
  },
  {
    name: "DIY Stitched Toys",
    date: "2019",
    description:
      "I was the team coordinator and design lead within a team of four for an automated web application that produces customisable and buildable stitched toy kits. I designed the UI and implemented all front-end aside from the drawing editor. The project was awarded first in the cohort.",

    imageLink: require("@/assets/images/bear_b.jpg"),
    buttons: [
      {
        label: "Video Demo",
        link: "./files/stitched_toys.mp4"
      }
    ],
    categories: ["HIGHLIGHTS", "WEB DEV"],
    tags: ["Vue.js", "SCSS"]
  },
  {
    name: "Kitsune Game",
    date: "2019",
    description:
      "Developer in a team of two for a 3D survival / RPG / tower defence game developed in Unity. I designed the map using custom Blender models and basic environment prefabs. I also implemented character animations, UI menus and sound effects",
    imageLink: require("@/assets/images/kitsune.jpg"),
    categories: ["TECH"],

    tags: ["Unity"]
  },
  {
    name: "Collaborative Path-Finding Robots",
    date: "2019",
    description:
      "Developer in a team of two for a cooperative path-finding and collision avoidance project that was demonstrated on low-cost robots in an unmapped environment. I improved the prebuilt robots’ odometry accuracy and implemented a messaging protocol for the robots to communicate obstacle locations and movement trajectories.",

    imageLink: require("@/assets/images/path_finding.jpg"),
    buttons: [
      {
        label: "Video Demo",
        link: "./files/pathfinding_difficult_obstacles.mp4"
      }
    ],
    categories: ["HIGHLIGHTS", "TECH"],

    tags: ["Python"]
  },
  {
    name: "Infosys Internship Experience Article",
    date: "2019",
    description:
      "My article 'Applying for the World’s No. 1 Internship - InStep' details my experience as an intern in India, with Infosys’ global internship program, InStep. It aims to encourage students who are considering applying for the InStep program and to give insight into what to expect before and during the internship.",
    imageLink: require("@/assets/images/instep.jpg"),

    buttons: [
      {
        label: "View Article",
        link:
          "https://anastasia-laczko.medium.com/applying-for-the-worlds-no-1-internship-instep-aa4190347ce9"
      }
    ],
    categories: ["CONTENT"]
  },
  {
    name: "SLAM Robot Concept Design",
    date: "2019",
    description:
      "As part of Infosys’s largest collaborative intern project, I designed concept illustrations for a small-scale SLAM robot.",
    imageLink: require("@/assets/images/ekanaina.jpg"),
    categories: ["DESIGN"],
    tags: ["Adobe Illustrator"]
  },
  {
    name: "UQ’s Version Control Course",
    date: "2019",
    description:
      "I co-wrote UQ’s official edX edge course: Introduction to Version Control with Git. This online course is to be used across multiple UQ courses and taught to all UQ information technology students.",
    imageLink: require("@/assets/images/edge.jpg"),
    categories: ["TECH", "CONTENT"]
  },
  {
    name: "Freeform Business Services Website",
    date: "2019",
    description:
      "I created a new website for Freeform Business Services, a local accounting business.",

    imageLink: require("@/assets/images/freeform.jpg"),

    buttons: [
      {
        label: "Visit Site",
        link: "http://www.goldcoastbookkeeping.com/"
      }
    ],
    categories: ["WEB DEV"],
    tags: ["WordPress"]
  },
  // {
  //   name: "Artworks for UQ Donor Relations",
  //   date: "2019",
  //   description:
  //     "Commissioned by the UQ Donor Relations team to create three UQ-inspired artworks to feature on Thank You cards for UQ donors.",
  //   imageLink: require("@/assets/images/forgan_smith.png"),
  //   categories: ["DESIGN"]
  // },
  {
    name: "Web Design Article",
    date: "2019",
    description:
      "My article 'Making Your Own Student Website Can Be as Easy as Baking a Cake' details the process of creating a student website. It covers website content development, design, prototyping, development tools, testing and hosting.",
    imageLink: require("@/assets/images/cake.jpg"),

    buttons: [
      {
        label: "View Article",
        link:
          "https://anastasia-laczko.medium.com/making-your-own-student-website-can-be-as-easy-as-baking-a-cake-da76c134a22a"
      }
    ],
    categories: ["WEB DEV", "CONTENT"]
  },
  // {
  //   name: "Digital Vector Illustration",
  //   date: "2019",
  //   description:
  //     "Designed a vector illustration using Adobe Illustrator for my website. The original design was sketched by hand and then digitally redrawn using a Wacom tablet.",
  //   imageLink: require("@/assets/images/desktop.png"),
  //   categories: ["HIGHLIGHTS", "DESIGN"],
  //   tags: ["Adobe Illustrator"]
  // },
  // {
  //   name: "The Visiting Album",
  //   date: "2019",
  //   description:
  //     "Designed “The Visiting Album”, a physically interactive photo album created to assist people living with dementia with preparing for visits from family, friends and carers.",
  //   dotPoints: [
  //     "The album is implemented as a dynamic webpage and is displayed through a tablet enclosed inside of a book.",
  //     "Page turning is controlled via physical buttons using a Makey Makey."
  //   ],
  //   imageLink: require("@/assets/images/visiting_album.jpg"),
  //   buttons: [
  //     {
  //       label: "Documentation",
  //       link: "./files/the_visiting_album.pdf"
  //     }
  //   ],
  //   categories: ["DESIGN"],
  //   tags: ["JavaScript"]
  // },
  // {
  //   name: "Mechatronics Team Project I: Killer Satellite",
  //   date: "2018",
  //   description:
  //     "Programming lead for a hanging satellite made to detect and fire a laser at surrounding infrared beacons.",
  //   dotPoints: [
  //     "Implemented embedded systems code on an Atmel microcontroller in C.",
  //     "Programmed a PID controller which uses infrared sensors as feedback.",
  //     "Multi-disciplinary project completed in a team of four."
  //   ],
  //   imageLink: require("@/assets/images/satellite.jpg"),
  //   buttons: [
  //     {
  //       label: "Video Demo",
  //       link: "./files/satellite_pid_control.MOV"
  //     }
  //   ],
  //   categories: ["TECH"],
  //   tags: ["C"]
  // },
  // {
  //   name: "ColoChat",
  //   date: "2018",
  //   description:
  //     "Project coordinator and lead UX designer for an interactive Vue.js web-app and chatbot.",
  //   dotPoints: [
  //     "Designed and storyboarded ColoChat’s user interface and interactivity.",
  //     "Created koala illustrations in Adobe Illustrator.",
  //     "Collected and implemented usability testing feedback.",
  //     "ColoChat was awarded the “People’s Choice Award” at the course tradeshow."
  //   ],
  //   imageLink: require("@/assets/images/colo.jpg"),
  //   buttons: [{ label: "Visit Site", link: "https://colochat.netlify.app/" }],
  //   categories: ["HIGHLIGHTS", "WEB DEV", "DESIGN"],
  //   tags: ["Vue.js", "Adobe Illustrator"]
  // },
  // {
  //   name: 'Cardboard Robot',
  //   date: '2018',
  //   description:
  //     'Little Inventor’s collaborative design challenge with Chinese secondary school and UQ students.',
  //   dotPoints: [
  //     'Started with a young child’s drawing of their invention, a robot, and built it out of cardboard.',
  //     'Overcame the language barrier by using innovative communication methods.',
  //     'During the final presentations, our robot was awarded the most impressive creation.'
  //   ],
  //   imageLink: require('@/assets/images/cardboard_robot.jpg'),
  //   categories: ['DESIGN']
  // },
  // {
  //   name: 'Resume Writing Article',
  //   date: '2018',
  //   description:
  //     '"What Australia-China Companies Really Want on Your Resume."',
  //   dotPoints: [
  //     'This article details resume writing advice collated at the 2018 Australia-China Careers Fair in Shanghai.',
  //     'Poll and interviews were conducted on several recruiters, career advisors and various company employees.'
  //   ],
  //   imageLink: require('@/assets/images/resume.jpg'),

  //   buttons: [
  //     { label: 'View Article', link: 'https://medium.com/@anastasia.laczko/what-australia-china-companies-really-want-on-your-resume-850a97e0bb6b' }
  //   ],
  //   categories: ['CONTENT']
  // }
  {
    name: "Digital Illustration",
    date: "2018",
    description: "Self portrait drawn using Clip Studio and a Wacom tablet.",
    imageLink: require("@/assets/images/me-landscape.png"),
    categories: ["DESIGN"]
  }
  // {
  //   name: "CC Transport App",
  //   date: "Jul 2017",
  //   description:
  //     "Developed an app aiming to reduce vehicle pollution in China through gamification.",
  //   dotPoints: [
  //     "Designed the app’s features, user interface and illustrations, as well as a website using Bootstrap.",
  //     "Project was completed in a team of six."
  //   ],
  //   imageLink: require("@/assets/images/cc.jpg"),
  //   buttons: [{ label: "Visit Site", link: "https://cchapy.netlify.app/" }],
  //   categories: ["WEB DEV", "DESIGN"],
  //   tags: ["JavaScript", "Adobe Photoshop"]
  // }
];
